exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2nnJH{border:1px solid #ddd}._2nnJH+._2nnJH{margin-top:16px;margin-top:1rem}._2nnJH h4{font-size:1.125em;margin-top:32px;margin-top:2rem;margin-bottom:0}@media screen and (min-width:768px){._2nnJH h4{font-size:1.25em}}._3fB0l{font-size:1.125em;margin:0;background-color:#f4f4ec;line-height:24px}@media screen and (min-width:768px){._3fB0l{font-size:1.25em}}._1Om36{padding:16px;padding:1rem;background-color:#fff}._1Om36 p:first-child{margin-top:0}._1Om36 a{font-weight:500;text-decoration:none}@media screen and (min-width:768px){._1Om36{max-width:800px;padding:1.5rem 2rem}}._2YBgV{border:0;padding:16px;padding:1rem;display:block;width:100%;background-color:transparent;text-align:left;cursor:pointer;outline:none;-webkit-appearance:none}._2YBgV .material-icons{color:#6eb658;float:right}@media screen and (min-width:768px){._2YBgV{padding:1.5rem 2rem}}.HKh3u{color:#333;font-weight:400}.HKh3u:after{margin-right:4px;margin-right:.25rem;content:\":\"}.r7GAK,.r7GAK ._2YBgV,.r7GAK ._3fB0l{background-color:#fff}.r7GAK ._2YBgV{color:#6eb658;font-weight:600}.r7GAK+.r7GAK{border-top:0;margin-top:0}", ""]);

// exports
exports.locals = {
	"root": "_2nnJH",
	"title": "_3fB0l",
	"content": "_1Om36",
	"button": "_2YBgV",
	"pre": "HKh3u",
	"inverse": "r7GAK"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":{"discardComments":{"removeAll":true}}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Fact/Fact.css
// module id = 674
// module chunks = 0 1